import React, { useEffect, useState } from "react";
import app from "./base.js";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  // NB: current user corresponds to the profiles table in firestore
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);

  const loading = (
    <div className="pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );

  useEffect(() => {
    app.auth().onAuthStateChanged(async (user) => {
      console.log("Auth state changed:", user);
      if (user != null) {
        console.log("User authenticated, fetching profile for UID:", user.uid);
        try {
          const profileQuery = app
            .firestore()
            .collection("profiles")
            .where("id", "==", user.uid);
          
          console.log("Profile query:", profileQuery);
          console.log("Querying for user UID:", user.uid);
          
          const snapshot = await profileQuery.get();
          console.log("Profile snapshot:", snapshot);
          console.log("Number of docs found:", snapshot.docs.length);
          
          if (snapshot.docs.length > 0) {
            const profileData = snapshot.docs[0].data();
            console.log("Profile data loaded:", profileData);
            console.log("Profile fields:", Object.keys(profileData));
            
            // Check the actual admin fields that exist in the profile
            console.log("Admin access fields:");
            console.log("admin_cms:", profileData.admin_cms, "type:", typeof profileData.admin_cms);
            console.log("isAdminOnCMS:", profileData.isAdminOnCMS, "type:", typeof profileData.isAdminOnCMS);
            console.log("Has admin access:", profileData.admin_cms === true || profileData.isAdminOnCMS === true);
            
            // Log the complete profile structure for debugging
            console.log("Complete profile structure:", JSON.stringify(profileData, null, 2));
            
            // Check if any field contains "admin" or "cms" in the name
            const adminFields = Object.keys(profileData).filter(key => 
              key.toLowerCase().includes('admin') || 
              key.toLowerCase().includes('cms') ||
              key.toLowerCase().includes('role') ||
              key.toLowerCase().includes('type')
            );
            console.log("Potential admin-related fields:", adminFields);
            
            setCurrentUser(profileData);
          } else {
            console.log("No profile found for user UID:", user.uid);
            // Try alternative field names
            const altQuery = app
              .firestore()
              .collection("profiles")
              .where("uid", "==", user.uid);
            const altSnapshot = await altQuery.get();
            console.log("Alternative query (uid field) found:", altSnapshot.docs.length, "docs");
            if (altSnapshot.docs.length > 0) {
              const altProfileData = altSnapshot.docs[0].data();
              console.log("Alternative profile data:", altProfileData);
              setCurrentUser(altProfileData);
            } else {
              setCurrentUser(null);
            }
          }
        } catch (err) {
          console.log("Error fetching profile:", err);
          setCurrentUser(null);
        }
      } else {
        console.log("No user authenticated");
        setCurrentUser(null);
      }
      setPending(false);
    });
  }, []);

  if (pending) {
    return <>{loading}</>;
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
